module.exports = __webpack_public_path__ + "img/qr-slide-mob-1.b1204266.png";